import { css } from 'react-emotion';
import { colors, fontFamily } from '../../variables';
import { ColorTypes } from '@joykit/variables/colors';

const borderColor = (error: boolean, noFocus: boolean, errorOnly: boolean = false) => {
  if (noFocus) {
    return colors.light;
  } else {
    if (error) {
      return colors.bad;
    } else if (errorOnly) {
      return 'transparent';
    } else {
      return colors.action;
    }
  }
};

export namespace styles {
  export const groupWrapper = (error: boolean = false, noFocus: boolean = false) =>
    css({
      fontFamily,
      backgroundColor: '#fff',
      borderColor: borderColor(error, noFocus, true),
      borderWidth: 1,
      borderStyle: 'solid',
      borderRadius: '.3rem',
      padding: '0 1rem',
      margin: '8px 0',
      fontSize: '1rem',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      position: 'relative',
      ':focus-within': {
        borderColor: borderColor(error, noFocus),
        outline: 'none',
        boxShadow: `0 0 0 1px ${borderColor(error, noFocus)}`
      }
    });

  export const subtitlesContainer = css({
    marginTop: 15
  });

  export const subtitleRow = (color: ColorTypes = 'outline') =>
    css({
      color: colors[color],
      fontSize: 14,
      letterSpacing: '.2px'
    });
}
